// extracted by mini-css-extract-plugin
export default {"languageSwitcher":"style_languageSwitcher__N--0p","dropdown":"style_dropdown__SHP-R","languageSwitcherSettings":"style_languageSwitcherSettings__Grs36"};